import React, { memo, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { followSwitching } from '../../../Store/actions/channelActions';
// import ReactHtmlParser from 'react-html-parser';
import { reactHtmlParser } from '../../../common/common';
import { useTracker } from '../../../TrackerFolder/TrackerComponent';
import useRedirect from '../../customHooks/useRedirect';
import './css/contentChannel.scss';
import LazyImage from '../../CustomLibraries/LazyImage';
import { content_channel_card_static_image } from '../../../common/assets.common';
import { Skeleton } from '../../../skeleton/Skeleton';
const ContentChannelCard = ({ data = null, loader, id = '', gtmTagVariable = '' }) => {
  const { redirectTo } = useRedirect();
  const [disabled, setDisabled] = useState(false);
  const [btn, setBtnVal] = useState('');
  const disptach = useDispatch();
  const { trackActivityEvent } = useTracker();
  const click = () => {
    redirectTo('ChannelProfile', data?.channel_id, data?.title);
  };
  const checkButtonByFollowedStatus = (followed_status) => {
    if (followed_status == 1) {
      setBtnVal('Access Requested');
      setDisabled(true);
    } else if (followed_status == 3) {
      setBtnVal('Unfollow');
    } else if (followed_status == 0) {
      if (data?.privacy_status == 1) {
        setBtnVal('Request Access');
      } else {
        setBtnVal('Follow');
      }
    }
  };
  useEffect(() => {
    checkButtonByFollowedStatus(data?.followed_status);
  }, [data]);

  const followSwitch = () => {
    disptach(
      followSwitching(data?.channel_id, (response) => {
        console.log('Switch', response.data);
        checkButtonByFollowedStatus(response.data);
      })
    );
  };
  const ChannelContentCardSkeleton = () => {
    return (
      <div className="w-100 float-start cmnContentChannelCard text-start d-flex justify-content-between align-items-start align-items-md-center py-3 px-4 my-3 rounded">
        <div className="chnlMngCrdIcon rounded-circle bg-white border border-light d-inline-flex justify-content-center align-items-center cursorPointer overflow-hidden">
          <Skeleton
            className="chnlCardProfile position-absolute"
            variant="circular"
            height={60}
            width={60}
          />
        </div>
        <div className="chnlMngCrdRight ps-4 ps-lg-5 position-relative">
          <h3>
            <a href="javascript:void(0)" className="text-black fs-3 fw-medium">
              <Skeleton variant="text" width="70%" height="20%" />
            </a>
          </h3>
          <h5 className="fs-4">
            <Skeleton variant="text" width="40%" height="20%" />
          </h5>
          <a
            href="javascript:void(0)"
            className="btn btn-black position-absolute top-50 end-0 translate-middle-y px-4 py-3 py-md-4 mt-3 mt-md-0 fw-medium fs-4 rounded"
            style={{ backgroundColor: 'white' }}
          >
            <Skeleton
              style={{ borderRadius: '5px' }}
              variant="rectangular"
              width={110}
              height={40}
            />
          </a>
        </div>
      </div>
    );
  };
  return data && !loader ? (
    <div className="w-100 float-start cmnContentChannelCard border-light border text-start d-flex justify-content-between align-items-start align-items-md-center py-3 px-4 my-3 rounded">
      <div
        className="chnlMngCrdIcon rounded-circle bg-white border border-light d-inline-flex justify-content-center align-items-center cursorPointer overflow-hidden"
        onClick={click}
      >
        <LazyImage
          src={data?.logo}
          className={`chnlCardProfile position-absolute w-auto h-auto top-50 start-50 translate-middle gtm_cl_contentChannelCard`}
          alt="channel profile image"
          logo
          // id={`${id}_channel_content_card_image`}
        />
      </div>
      <div className="chnlMngCrdRight ps-4 ps-lg-5 position-relative">
        <h3 onClick={click}>
          <a
            href="javascript:void(0)"
            className={`text-black fs-3 fw-medium gtm_cl_contentChannelCard`}
            // id={`${id}_channel_content_card_title`}
          >
            {data?.title}
          </a>
        </h3>
        <h5
          className={`fs-4 cursorPointer gtm_cl_contentChannelCard`}
          onClick={click}
          // id={`${id}_channel_content_card_description`}
        >
          {reactHtmlParser(data?.description)}
        </h5>
        {btn && (
          <button
            href="javascript:void(0)"
            className={`rippleEffect btn btn-black position-absolute top-50 end-0 translate-middle-y px-4 py-3 py-md-4 mt-3 mt-md-0 fw-medium fs-4 rounded gtm_cl_contentChannelCard_followUnfollow`}
            disabled={disabled}
            onClick={followSwitch}
          >
            <span
              // id={`${id}_channel_content_card_followUnfollow_button`}
              className={`gtm_cl_contentChannelCard_followUnfollow`}
            >
              {' '}
              {btn}{' '}
            </span>
          </button>
        )}
      </div>
    </div>
  ) : loader ? (
    <ChannelContentCardSkeleton />
  ) : (
    <></>
  );
};

export default memo(ContentChannelCard);
